// DataContext.tsx
import React, { ReactNode, createContext, useContext, useState } from 'react';

interface RoomArrayContextProps {
    roomArray: string[];
    updateArray: (newData: any) => void;
}

const RoomArrayContext = createContext<RoomArrayContextProps | undefined>(undefined);

interface RoomArrayProviderProps {
    children: ReactNode;
  }

export const RoomArrayProvider: React.FC<RoomArrayProviderProps> = ({ children }) => {
  const [roomArray, setRoomArray] = useState<string[]>([]);

  const updateArray = (newData: any) => {
    setRoomArray(newData);
  };

  return (
    <RoomArrayContext.Provider value={{ roomArray, updateArray }}>
      {children}
    </RoomArrayContext.Provider>
  );
};

export const useRoomArrayContext = (): RoomArrayContextProps => {
  const context = useContext(RoomArrayContext);
  if (!context) {
    throw new Error('useDataContext must be used within a DataProvider');
  }
  return context;
};
